import { yupResolver } from '@hookform/resolvers/yup';
import { FormActions } from '@openx/components-core/lib/FormActions/FormActions';
import { FormContainer } from '@openx/components-core/lib/FormContainer/FormContainer';
import { scrollToError } from '@openx/components-core/utils/scrollToError';
import { PageHeader } from '@openx/components-header/PageHeader';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { useProviderContext } from '../../utils/context/ProviderContext';
import { initialFormState } from '../constants';
import type { ProviderFormState } from '../types';
import { ProviderDetailsSections } from './sections/ProviderDetailsSections';
import { transformCreateFormDataToApiPayload } from './utils';
import { getValidationSchema } from './validationSchema';

export const ProviderCreateForm = () => {
  const { useCreateProvider } = useProviderContext();
  const { createProvider, loading } = useCreateProvider();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const formMethods = useForm<ProviderFormState>({
    defaultValues: initialFormState,
    mode: 'all',
    resolver: yupResolver(getValidationSchema(t)),
  });

  const onSubmit = (data: ProviderFormState) => {
    const payload = transformCreateFormDataToApiPayload(data);
    createProvider(payload);
  };

  return (
    <PageHeader title={t('Create New Provider')} titlePrefix="OpenXSelect">
      <FormProvider {...formMethods}>
        <form onSubmit={formMethods.handleSubmit(onSubmit, scrollToError)}>
          <FormContainer fullPage>
            <ProviderDetailsSections />

            <FormActions
              submitButtonLabel={t('Save')}
              cancelButtonLabel={t('Cancel')}
              onCancel={() => navigate('/providers')}
              isSubmitting={loading}
            />
          </FormContainer>
        </form>
      </FormProvider>
    </PageHeader>
  );
};
